import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Memberprofile } from '../models/memberprofile.model';
import { CrudService } from '../service/crud.service';
import { ECRService } from '../service/ecr.service';
import { ProfileService } from '../service/profile.service';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-memberprofile',
  templateUrl: './memberprofile.component.html',
  styleUrls: ['./memberprofile.component.css']
})
export class MemberprofileComponent implements OnInit {

  _ProfileModel: Memberprofile = new Memberprofile();
  DisableSubmitButton: boolean = false;
  EmployeeDetails: any;
  url: any = null;
  msg = "";
  filesToUpload: any[] = [];
  FileUpload: any = [];
  files: any[] = [];
  MinDate: Date = new Date();
  MaxDate: Date = new Date();
  UpdateDate: any;
  todayDate: any;
  HideSubmitButton: boolean = false;
  dataNotAvalaible: boolean = true;

  showCropModal = false;
  cropImageSrc: string = null;
  cropZoom = 1;
  cropOffsetX = 0;
  cropOffsetY = 0;
  isCropDragging = false;
  private cropDragStartX = 0;
  private cropDragStartY = 0;
  private cropOffsetStartX = 0;
  private cropOffsetStartY = 0;
  private pendingFileName = 'profile.jpg';
  private cropImage: HTMLImageElement = null;
  private readonly cropViewportSize = 280;
  private readonly cropOutputSize = 400;

  @ViewChild('cropCanvas', { static: false }) cropCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild('previewCanvas', { static: false }) previewCanvas: ElementRef<HTMLCanvasElement>;

  constructor(private _ecrService: ECRService, private _profileSer: ProfileService, private route: ActivatedRoute,
    public _sharedSer: SharedService, private _router: Router, private _crudSer: CrudService) {
    this._ProfileModel.MEMBER_TMC = sessionStorage.getItem("userId");
  }

  ngOnInit() {
    this.GetServerDate();

    // debugger;
    if (!this._sharedSer.checkProperty(this._ProfileModel.MEMBER_TMC)) {
      this.getProfileDetails();
    }
    this._ProfileModel.MEMBER_TMC = sessionStorage.getItem("userId");
    this._ProfileModel.MEMBER_NAME = sessionStorage.getItem("FullName");
    this._ProfileModel.MEMBER_BRANCH_NAME = sessionStorage.getItem("UserLocation");
    this._ProfileModel.MEMBER_EMAIL = sessionStorage.getItem("UserEmail");
    this._ProfileModel.MEMBER_DEPARTMENT = sessionStorage.getItem("UserDepartment");
    this._ProfileModel.MEMBER_DESIGNATION = sessionStorage.getItem("UserDesignation");
    this._ProfileModel.DATE_OF_JOINING = sessionStorage.getItem("DOJ");
    this._ProfileModel.MEMBER_SBU = sessionStorage.getItem("UserSBU");
    this._ProfileModel.Member_Functional_Area = sessionStorage.getItem("functionalAreaName");
    this._ProfileModel.Mobile_Phone_No = sessionStorage.getItem("phoneNo");

    //this.UpdateDate =sessionStorage.getItem("DOJ");

    // this.UpdateDate ="2022-04-08T00:00:00";
    // this.UpdateDate = this.UpdateDate.toISOString().split('T')[0];


    //   this._ProfileModel.MEMBER_REPORTING_MANAGER=sessionStorage.getItem("ReportingHeadId");

    //    this._ProfileModel.MEMBER_SBU_HEAD=sessionStorage.getItem("UserSBUCode");


    this.GetReportingDetails(this._ProfileModel.MEMBER_TMC);
    this.GetSBUHead(this._ProfileModel.MEMBER_SBU);
    this.GetAllPIDocuments(this._ProfileModel.MEMBER_TMC);
  }



  oneWeekBefore: any;
  GetServerDate() {
    let promise = new Promise<any>((resolve, reject) => {
      this._ecrService.GeServerDate().toPromise()
        .then(r => {
          var parts = r.Data.split('/');
          this.todayDate = new Date(parts[2], parts[1] - 1, parts[0]);
          var date = new Date(this.todayDate);
          this.oneWeekBefore = new Date(date.setDate(date.getDate() - 30));

          resolve(r);
        })
        .catch(error => {
          Promise.reject(error);
        }
        );
    });
    return promise;
  }

  IsProfileEditable(joiningdate) {
    var jDate = new Date(joiningdate);
    // console.log('one', this.oneWeekBefore);
    // console.log('joiningdate', joiningdate);
    if (jDate >= this.oneWeekBefore && jDate <= this.todayDate)
      return true;
    else
      return false;
  }

  getProfileDetails() {

    this._profileSer.GetProfileDetailsById(this._ProfileModel.MEMBER_TMC).subscribe(
      data => {
        if (data.Status) {
          if (data.Data != null) {
            this._ProfileModel = data.Data;
            this._ProfileModel.MEMBER_TMC = sessionStorage.getItem("userId");
            this._ProfileModel.MEMBER_NAME = sessionStorage.getItem("FullName");
            this._ProfileModel.MEMBER_BRANCH_NAME = sessionStorage.getItem("UserLocation");
            this._ProfileModel.MEMBER_EMAIL = sessionStorage.getItem("UserEmail");
            this._ProfileModel.MEMBER_DEPARTMENT = sessionStorage.getItem("UserDepartment");
            this._ProfileModel.MEMBER_DESIGNATION = sessionStorage.getItem("UserDesignation");
            this._ProfileModel.DATE_OF_JOINING = sessionStorage.getItem("DOJ");
            this._ProfileModel.Member_Functional_Area = sessionStorage.getItem("functionalAreaName");
            this._ProfileModel.MEMBER_SBU = sessionStorage.getItem("UserSBU");
            this._ProfileModel.Mobile_Phone_No = sessionStorage.getItem("phoneNo");
          }

          this.GetReportingDetails(this._ProfileModel.MEMBER_TMC);
          this.GetSBUHead(this._ProfileModel.MEMBER_SBU);


        }
      }, error => console.error());
  }

  GetReportingDetails(TmcNo: string) {


    if (TmcNo != '' && TmcNo != undefined) {

      this._ecrService.GetReportingHeadDetails(TmcNo).subscribe(
        data => {
          if (data.Status) {
            this.EmployeeDetails = data.Data;
            this._ProfileModel.MEMBER_REPORTING_MANAGER = data.Data.Full_Name;

          }
        },
        error => {
          console.log(error);
          console.error();
        }
      );

    }
  }

  GetSBUHead(SBUCode: string) {


    if (SBUCode != '' && SBUCode != undefined) {

      this._profileSer.GetSBUHeadDetails(SBUCode).subscribe(
        data => {
          if (data.Status) {
            // this.EmployeeDetails = data.Data;
            this._ProfileModel.MEMBER_SBU_HEAD = data.Data;

          }
        },
        error => {
          console.log(error);
          console.error();
        }
      );

    }
  }

  validate() {
    if (this._sharedSer.checkProperty(this._ProfileModel.MEMBER_HOME)) {
      Swal.fire({
        toast: true,
        title: 'Enter Hometown',
        icon: 'error',
        position: 'top',
        width: 350,
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })
      return true;
    }
    else if (this._sharedSer.checkProperty(this._ProfileModel.MEMBER_DEGREE)) {
      Swal.fire({
        toast: true,
        title: 'Enter Educational Degree',
        icon: 'error',
        position: 'top',
        width: 350,
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })
      return true;
    }
    else if (this._sharedSer.checkProperty(this._ProfileModel.MEMBER_PROF_LOCATION)) {

      Swal.fire({
        toast: true,
        title: 'Enter Institution Name, Place',
        icon: 'error',
        position: 'top',
        width: 350,
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,

        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      return true;
    }
    else if (this._ProfileModel.MEMBER_EXP_TYPE == "Experience" && this._sharedSer.checkProperty(this._ProfileModel.MEMBER_EXPERIENCE)) {
      Swal.fire({
        toast: true,
        title: 'Enter Experience',
        icon: 'error',
        position: 'top',
        width: 350,
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,

        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      return true;
    }

    else if (this._sharedSer.checkProperty(this._ProfileModel.MEMBER_PROF_DOMAIN)) {
      Swal.fire({
        toast: true,
        title: 'Enter Discipline ',
        icon: 'error',
        position: 'top',
        width: 350,
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })
      return true;
    }

    else if (this._ProfileModel.MEMBER_EXP_TYPE == "Experience" && this._sharedSer.checkProperty(this._ProfileModel.MEMBER_INTEREST)) {
      Swal.fire({
        toast: true,
        title: 'Please enter your Field of Experience or Area of Expertise',
        icon: 'error',
        position: 'top',
        width: 350,
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,

        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      return true;
    }
    else if (this._sharedSer.checkProperty(this._ProfileModel.Member_Hobbies)) {
      Swal.fire({
        toast: true,
        title: 'Please enter your Interests and Hobbies',
        icon: 'error',
        position: 'top',
        width: 350,
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,

        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      return true;
    }

    else if (this.files.length <= 0) {

      Swal.fire({
        toast: true,
        title: 'Please upload Profile Image',
        icon: 'error',
        position: 'top',
        width: 350,
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })
      return true;
    }

    else {
      return false;
    }
  }

  uploadFile(event: any) {
    const input = event.target;
    if (!input.files || !input.files[0]) {
      this.msg = 'You must select an image';
      return;
    }

    const file = input.files[0];
    const mimeType = file.type;

    if (!mimeType || mimeType.match(/image\/*/) == null) {
      this.msg = 'Only images are supported';
      return;
    }

    if (!this.validateFile(file.name)) {
      Swal.fire({
        toast: true,
        title: 'Invalid File Format',
        icon: 'error',
        position: 'top',
        width: 350,
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
      });
      return;
    }

    this.pendingFileName = file.name;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.msg = '';
      this.cropImageSrc = reader.result as string;
      this.cropZoom = 1;
      this.cropOffsetX = 0;
      this.cropOffsetY = 0;
      this.showCropModal = true;
      setTimeout(() => this.initCropEditor(), 0);
    };
  }

  initCropEditor() {
    if (!this.cropImageSrc) {
      return;
    }
    this.cropImage = new Image();
    this.cropImage.onload = () => this.redrawCropCanvases();
    this.cropImage.onerror = () => {
      this._sharedSer.SwalErrorMsg('Unable to load the selected image');
      this.cancelCrop();
    };
    this.cropImage.src = this.cropImageSrc;
  }

  onCropZoomChange() {
    this.redrawCropCanvases();
  }

  startCropDrag(event: MouseEvent | TouchEvent) {
    if (!this.showCropModal) {
      return;
    }
    event.preventDefault();
    const point = this.getPointerPosition(event);
    this.isCropDragging = true;
    this.cropDragStartX = point.x;
    this.cropDragStartY = point.y;
    this.cropOffsetStartX = this.cropOffsetX;
    this.cropOffsetStartY = this.cropOffsetY;
  }

  @HostListener('document:mousemove', ['$event'])
  onCropDragMove(event: MouseEvent) {
    if (!this.isCropDragging) {
      return;
    }
    this.cropOffsetX = this.cropOffsetStartX + (event.clientX - this.cropDragStartX);
    this.cropOffsetY = this.cropOffsetStartY + (event.clientY - this.cropDragStartY);
    this.redrawCropCanvases();
  }

  @HostListener('document:mouseup')
  onCropDragEnd() {
    this.isCropDragging = false;
  }

  @HostListener('document:touchmove', ['$event'])
  onCropTouchMove(event: TouchEvent) {
    if (!this.isCropDragging || !event.touches.length) {
      return;
    }
    event.preventDefault();
    const touch = event.touches[0];
    this.cropOffsetX = this.cropOffsetStartX + (touch.clientX - this.cropDragStartX);
    this.cropOffsetY = this.cropOffsetStartY + (touch.clientY - this.cropDragStartY);
    this.redrawCropCanvases();
  }

  @HostListener('document:touchend')
  onCropTouchEnd() {
    this.isCropDragging = false;
  }

  private getPointerPosition(event: MouseEvent | TouchEvent) {
    if (event instanceof TouchEvent) {
      const touch = event.touches[0] || event.changedTouches[0];
      return { x: touch.clientX, y: touch.clientY };
    }
    return { x: event.clientX, y: event.clientY };
  }

  private getCropScale(image: HTMLImageElement): number {
    const baseScale = Math.max(
      this.cropViewportSize / image.width,
      this.cropViewportSize / image.height
    );
    return baseScale * this.cropZoom;
  }

  private drawCroppedImage(
    ctx: CanvasRenderingContext2D,
    image: HTMLImageElement,
    size: number
  ) {
    const scale = this.getCropScale(image);
    const drawWidth = image.width * scale;
    const drawHeight = image.height * scale;
    const x = (size - drawWidth) / 2 + this.cropOffsetX;
    const y = (size - drawHeight) / 2 + this.cropOffsetY;

    ctx.clearRect(0, 0, size, size);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, size, size);
    ctx.drawImage(image, x, y, drawWidth, drawHeight);
  }

  redrawCropCanvases() {
    if (!this.cropImage || !this.cropCanvas || !this.previewCanvas) {
      return;
    }

    const mainCanvas = this.cropCanvas.nativeElement;
    const previewCanvas = this.previewCanvas.nativeElement;
    const mainCtx = mainCanvas.getContext('2d');
    const previewCtx = previewCanvas.getContext('2d');

    if (!mainCtx || !previewCtx) {
      return;
    }

    this.drawCroppedImage(mainCtx, this.cropImage, this.cropViewportSize);
    this.drawCroppedImage(previewCtx, this.cropImage, 140);
  }

  applyCrop() {
    if (!this.cropImage) {
      return;
    }

    const exportCanvas = document.createElement('canvas');
    exportCanvas.width = this.cropOutputSize;
    exportCanvas.height = this.cropOutputSize;
    const exportCtx = exportCanvas.getContext('2d');

    if (!exportCtx) {
      return;
    }

    const scale = this.getCropScale(this.cropImage);
    const drawWidth = this.cropImage.width * scale;
    const drawHeight = this.cropImage.height * scale;
    const ratio = this.cropOutputSize / this.cropViewportSize;
    const x = ((this.cropViewportSize - drawWidth) / 2 + this.cropOffsetX) * ratio;
    const y = ((this.cropViewportSize - drawHeight) / 2 + this.cropOffsetY) * ratio;

    exportCtx.fillStyle = '#ffffff';
    exportCtx.fillRect(0, 0, this.cropOutputSize, this.cropOutputSize);
    exportCtx.drawImage(
      this.cropImage,
      x,
      y,
      drawWidth * ratio,
      drawHeight * ratio
    );

    const dataUrl = exportCanvas.toDataURL('image/jpeg', 0.92);
    this.url = dataUrl;

    const blob = this.dataUrlToBlob(dataUrl);
    const fileName = this.getCroppedFileName(this.pendingFileName);
    const croppedFile = new File([blob], fileName, { type: 'image/jpeg' });

    this.FileUpload = [croppedFile];
    this.files = [{ name: fileName, DownloadFlag: false }];
    this.closeCropModal();
  }

  cancelCrop() {
    this.closeCropModal();
  }

  private closeCropModal() {
    this.showCropModal = false;
    this.isCropDragging = false;
    this.cropImageSrc = null;
    this.cropImage = null;
  }

  private getCroppedFileName(originalName: string): string {
    const base = originalName ? originalName.replace(/\.[^.]+$/, '') : 'profile';
    return base + '.jpg';
  }

  private dataUrlToBlob(dataUrl: string): Blob {
    const parts = dataUrl.split(',');
    const mime = parts[0].match(/:(.*?);/)[1];
    const binary = atob(parts[1]);
    const array = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      array[i] = binary.charCodeAt(i);
    }
    return new Blob([array], { type: mime });
  }

  validateFile(name: String) {
    var ext = name.substring(name.lastIndexOf('.') + 1);
    //.xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf
    if (ext.toLowerCase() == 'png' || ext.toLowerCase() == 'jpg'
      || ext.toLowerCase() == 'jpeg'
      || ext.toLowerCase() == 'gif'
      || ext.toLowerCase() == 'bmp'
      || ext.toLowerCase() == 'image/*'


    ) {
      return true;
    }
    else {
      return false;
    }
  }

  SaveProfileData() {
    if (this.validate()) {
      return;
    }
    this.DisableSubmitButton = true;
    this._ProfileModel.STATUS = "SUBMITTED";
    this._ProfileModel.CREATED_BY = sessionStorage.getItem('userId');
    this._ProfileModel.MODIFIED_BY = sessionStorage.getItem('userId');
    this._ProfileModel.CREATED_BY = sessionStorage.getItem('userId');
    this._ProfileModel.MODIFIED_BY = sessionStorage.getItem('userId');

    let formdata = new FormData();
    this._ProfileModel.MEMBER_TMC = sessionStorage.getItem('userId');;
    this._ProfileModel.MEMBER_NAME = sessionStorage.getItem('FullName');;
    //this._ProfileModel.MEMBER_REPORTING_MANAGER=sessionStorage.getItem('ReportingHeadId');
    this._ProfileModel.MEMBER_DEPARTMENT = sessionStorage.getItem('UserDepartment');
    this._ProfileModel.MEMBER_DESIGNATION = sessionStorage.getItem('UserDesignation');
    this._ProfileModel.MEMBER_SBU_CODE = sessionStorage.getItem('UserSBUCode');
    this._ProfileModel.MEMBER_SBU = sessionStorage.getItem('UserSBU');
    this._ProfileModel.MEMBER_SUB_BU = sessionStorage.getItem('UserSUBBU');
    this._ProfileModel.MEMBER_EMAIL = sessionStorage.getItem('UserEmail');
    this._ProfileModel.MEMBER_BRANCH_NAME = sessionStorage.getItem('UserLocation');
    this._ProfileModel.Member_Functional_Area = sessionStorage.getItem("functionalAreaName");
    this._ProfileModel.Mobile_Phone_No = sessionStorage.getItem("phoneNo");
    //this._ProfileModel.MEMBER_REPORTING_MANAGER = this._ProfileModel.MEMBER_REPORTING_MANAGER;

    if (this.FileUpload && this.FileUpload.length > 0) {
      this._ProfileModel.ProfileFileName = this.FileUpload[0].name;
    }
    if (this.url && this.url.includes(',')) {
      this._ProfileModel.ProfileFileBase64 = this.url.split(',')[1];
    }

    formdata.append("MemberProfile", JSON.stringify(this._ProfileModel));
    for (var i = 0; i < this.FileUpload.length; i++) {
      formdata.append(this.FileUpload[i].name, this.FileUpload[i]);
    }

    this._profileSer.SaveProfileDetails(formdata).subscribe(
      data => {
        if (data.Status) {

          this._sharedSer.SwalSuccessMsg('Profile Data updated successfully');
          this.getProfileDetails();
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
        else {
          //Swal.fire(data.Message); 
          this._sharedSer.SwalErrorMsg(data.Message);

          this.DisableSubmitButton = false;

        }
      }, error => console.error());
  }

  GetAllPIDocuments(DocumentNo: string) {
    console.log('DocumentNo111', DocumentNo);
    this._profileSer.GetAllDocuments(DocumentNo).subscribe(
      data => {
        console.log('DocumentNo222', DocumentNo)
        console.log("Full API Response:", data);
        console.log("Type of data:", typeof data);
        // debugger;
        if (data.indexOf('Could not find a part of the path') <= -1) {
          this.files = [];
          this.url = this._crudSer.profilesiteUrl + "PROFILEIMAGE/" + DocumentNo + "/" + data[0];
          data.forEach((element: any) => {
            this.files.push({ name: element, DownloadFlag: true })
          });
        }
        else {
          this.url = null;
        }
        console.log(this.url);
      }, error => console.error());
  }

  getAvatarInitials(): string {
    const name = this._ProfileModel.MEMBER_NAME || '';
    const parts = name.trim().split(/\s+/).filter(function (part) { return part.length > 0; });
    if (parts.length === 0) {
      return '';
    }
    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
    }
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }

  hasProfileImage(): boolean {
    return this.url !== null && this.url !== undefined && String(this.url).trim() !== '';
  }

  onProfileImageError(): void {
    this.url = null;
  }

}
